import "./index.css";
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useGameStore } from './store/gameStore';
import StartScreen from './screens/StartScreen';
import ProfileSelection from './screens/ProfileSelection';
import ProfileCreation from './screens/ProfileCreation';
import LevelSelection from './screens/LevelSelection';
import GamePlay from './screens/GamePlay';
import ProfileDashboard from './screens/ProfileDashboard';
import Statistics from './screens/Statistics';

export function App() {
  const { initializeApp, currentProfile } = useGameStore();

  useEffect(() => {
    initializeApp();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900">
        <Routes>
          <Route path="/" element={<StartScreen />} />
          <Route path="/profiles" element={<ProfileSelection />} />
          <Route path="/profile/new" element={<ProfileCreation />} />
          <Route 
            path="/levels" 
            element={currentProfile ? <LevelSelection /> : <Navigate to="/" />} 
          />
          <Route 
            path="/play/:level" 
            element={currentProfile ? <GamePlay /> : <Navigate to="/" />} 
          />
          <Route 
            path="/profile/dashboard" 
            element={currentProfile ? <ProfileDashboard /> : <Navigate to="/" />} 
          />
          <Route 
            path="/statistics" 
            element={currentProfile ? <Statistics /> : <Navigate to="/" />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;